import { render } from "./AirplaneTakeoffIcon.vue?vue&type=template&id=471eb128"
import script from "./AirplaneTakeoffIcon.vue?vue&type=script&lang=js"
export * from "./AirplaneTakeoffIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__